var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.buildHashChanged)?_c('div',{staticClass:"buildHash-changed-banner"},[_vm._v(" A new version of the application is available, please refresh the browser. ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }